<div [innerHTML]="localBusinessJsonLd()"></div>
<div [innerHTML]="webSiteJsonLd()"></div>

@if (maintenanceService.isMaintenanceInProgress()) {
  <oops-page />
} @else {
  <announcement />
  <router-outlet />
}

<noty />
<button-up />
<tc-icon-sprite style="display:none;visibility:hidden" />


<!-- showcase all icons -->
<!--@for (icon of AllMbiIcons; track icon) {-->
<!--  <i class="mbi {{ icon }}"></i>: {{ icon }}<br>-->
<!--}-->
